const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
const pathPrefix = basePath ? `/${basePath}` : "";

export function getAuthCallbackUrl(): string {
  return `${window.location.origin}${pathPrefix}/auth/callback`;
}

export function resolvePostAuthDestination(raw?: string | null): string {
  if (!raw) return "/admin";
  if (!raw.startsWith("/") || raw.startsWith("//")) return "/admin";

  const lower = raw.toLowerCase();
  if (
    lower === "/auth" ||
    lower.startsWith("/auth/") ||
    lower === "/login" ||
    lower === "/register" ||
    lower === "/forgot-password" ||
    lower === "/reset-password"
  ) {
    return "/admin";
  }
  return raw;
}